import { render } from "./collegeSearch.vue?vue&type=template&id=6f7590a4"
import script from "./collegeSearch.vue?vue&type=script&lang=js"
export * from "./collegeSearch.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__